<template>
    <div class="product">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="page-header">
                <h1>
                    {{room.title}}
                </h1>
            </div>

            <div class="row">
                <div class="col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12">
                    <form class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">Title</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" v-model="room.title">
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-sm-4 control-label">Description</label>
                            <div class="col-sm-8">
                                <textarea type="text" class="form-control" v-model="room.description"></textarea>
                            </div>
                        </div>

                        <br />

                        <div class="form-group">
                            <div class="col-sm-offset-4 col-sm-8">
                                <button type="submit" class="btn btn-primary" @click="update">Update room</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loader from '@/components/layout/Loader'

    const RoomService = require('@/services/rooms/RoomService')

    export default {
        data() {
            return {
                room: null,
                hasLoaded: false
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                RoomService.find(this.$route.params.id, {}, (response) => {
                    const data = response.data

                    this.room = data
                    this.hasLoaded = true
                })
            },

            update() {
                this.hasLoaded = false

                RoomService.update(this.$route.params.id, this.room, (response) => {
                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// View.vue?14cc6142